import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=4f97ab8c&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=4f97ab8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f97ab8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f97ab8c')) {
      api.createRecord('4f97ab8c', component.options)
    } else {
      api.reload('4f97ab8c', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=4f97ab8c&scoped=true&", function () {
      api.rerender('4f97ab8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/pages/Home.vue"
export default component.exports